import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconToast: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconToast"><Path d="M12 3C9.30467 3 6.84 3.63144 5.03197 4.6782C3.23688 5.71746 2 7.22766 2 9C2 10.4077 2.78397 11.6537 4 12.6223V18.5C4 19.8807 5.11929 21 6.5 21H17.5C18.8807 21 20 19.8807 20 18.5V12.6223C21.216 11.6537 22 10.4077 22 9C22 7.22766 20.7631 5.71746 18.968 4.6782C17.16 3.63144 14.6953 3 12 3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconToast;
